export default __webpack_public_path__ + "static/media/discordOnboarding.e324c9c0.svg";